<!--
  - Copyright (c) 2020. Minerva Networks.
  - All rights reserved.
  -->

<template lang="html">
  <section class="payment">
  </section>
</template>

<script lang="js">
import { mapActions, mapState, mapMutations } from 'vuex';
import get from 'lodash.get';

export default {
  name: 'payment',
  data() {
    return {
      get,
      amt: false,
      cc: false,
      cm: false,
      item_number: false,
      sig: false,
      st: false,
      tx: false,
    };
  },
  methods: {
    ...mapMutations(['initModal', 'redirectToIP', 'setLoginInfo']),
    ...mapActions(['appReady', 'getMe', 'getPlans']),
    // eslint-disable-next-line consistent-return
    getToken() {
      const status = this.getCookie(`${window.TOK_NS}storageAccessData`);
      if (status && status.token) {
        this.setLoginInfo(status);
        return status.token;
      }
      this.redirectToIP({
        // app: 'toktvsdk',
        // service: 'tokvp',
        registered: false,
        // returnUrl: `${this.baseUrl}login`,
      });
    },
    pollPaypalPayment(pppd) {
      const self = this;
      this.api.get('check-plan',
        {
          params: {
            type: pppd.type,
            sku: pppd.sku,
          },
          headers: {
            'Content-Type': 'application/json',
            'x-tok-token': self.getToken(),
          },
        })
        .then((response) => {
          if (response.data.active) {
            window.ga('tok.send', 'event', 'Subscription Paywall', 'Pay Item Acquired', get(pppd, 'id'));
            self.getMe()
              .then(() => {
                self.getPlans(true)
                  .then(() => {
                    self.$router.push('/paywall');
                  })
                  .catch(() => {
                    window.app.$log.info('Unable retrive plans');
                    self.$router.push('/paywall');
                  });
              })
              .catch(() => {
                window.app.$log.info('Unable to retrive user info');
                self.$router.push('/paywall');
              });
          } else {
            setTimeout(() => {
              self.pollPaypalPayment(pppd);
            }, 3000);
          }
        })
        .catch(() => {
          self.initModal({
            display: true,
            title: 'ERROR',
            text: 'Payment processing error',
            cta: this.$t('close'),
            callback: 'closeAnPayWall',
            animation: 'tada',
          });
        });
    },
  },
  computed: {
    ...mapState(['api', 'availablePlans']),
  },
  mounted() {
    const pppd = this.$ls.get('pppd');
    if (pppd) {
      this.pollPaypalPayment(pppd);
    } else {
      this.initModal({
        display: true,
        title: 'ERROR',
        text: 'No payment information supplied',
        cta: this.$t('close'),
        callback: 'closeAnPayWall',
        animation: 'tada',
      });
    }
    /*
    const self = this;
    const params = [
      'amt',
      'cc',
      'cm',
      'item_number',
      'sig',
      'st',
      'tx',
    ];
    for (let i = 0; i < params.length; i += 1) {
      this[params[i]] = this.$route.query[params[i]];
    }
    const that = this;
    this.api.post('/claim-plan',
      {
        type: 'paypal',
        paypal_sku: this.item_number,
        paypal_tx: this.tx,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'x-tok-token': self.getToken(),
        },
      })
      .then((response) => {
        if (response.data.valid) {
          const plan = find(get(that, 'availablePlans.plans', false), p => p.title === response.data.plan);
          if (plan) {
            window.ga('tok.send', 'event', 'Subscription Paywall', 'Pay Item Acquired', get(plan, 'id'));
          }
          that.getMe()
            .then(() => {
              that.getPlans(true)
                .then(() => {
                  that.$router.push('/paywall');
                })
                .catch(() => {
                  window.app.$log.info('Unable retrive plans');
                  that.$router.push('/paywall');
                });
            })
            .catch(() => {
              window.app.$log.info('Unable to retrive user info');
              that.$router.push('/paywall');
            });
        } else {
          that.initModal({
            display: true,
            title: 'ERROR',
            text: 'generic error',
            cta: this.$t('close'),
            callback: 'closeAnPayWall',
            animation: 'tada',
          });
        }
      })
      .catch((e) => {
        that.initModal({
          display: true,
          title: 'ERROR',
          text: 'Payment processing error',
          cta: this.$t('close'),
          callback: 'closeAnPayWall',
          animation: 'tada',
        });
      });
      */
  },
};
</script>

<style scoped lang="scss">
.payment {}
</style>
